import { Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { PaymentFormComponent } from './payment-form/payment-form.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { PaymentConfirmationComponent } from './payment-confirmation/payment-confirmation.component';
import { ExpiredLinkComponent } from './expired-link/expired-link.component';
import { UsedLinkComponent } from './used-link/used-link.component';
import { InactiveLinkComponent } from './inactive-link/inactive-link.component';
import { PaymentFailedComponent } from './payment-failed/payment-failed.component';
import { PaymentLoadingComponent } from './payment-loading/payment-loading.component';

export const routes: Routes = [
    {path:'',redirectTo:'not-found',pathMatch:'full'},
    {
        path: 'not-found',
        component: NotFoundComponent
    },
    {
        path: 'expired',
        component: ExpiredLinkComponent
    },
    {
        path: 'used',
        component: UsedLinkComponent
    },
    {
        path: 'inactive',
        component: InactiveLinkComponent
    },
    {
        path: 'payment/:method',
        component: PaymentFormComponent
    },
    {
        path: 'pay/confirmation',
        component: PaymentConfirmationComponent
    },
    {
        path: 'pay/processing',
        component: PaymentLoadingComponent
    },
    {
        path: 'pay/failed',
        component: PaymentFailedComponent
    },
    {
        path: ':linkId',
        component: HomeComponent
    },
];
